var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body__container--actions"},[_c('button',{staticClass:"help-btn",on:{"click":function($event){return _vm.$emit('onCallReception')}}},[_vm._v(" Chamar recepção ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }